module.exports = __webpack_public_path__ + "static/media/hero-image.ca0e7ee6.png";